module.exports = __webpack_public_path__ + "img/franchising_review_ava_2.788e1e96.png";